module.exports = __webpack_public_path__ + "img/turntable.68d52036.jpg";